import type { ReactElement } from 'react';
import CONSTANTS from '../constants';

// the visible mark is hidden from screen readers, which would otherwise read "Rx" as "rex" or announce the superscript
const BrandName = (): ReactElement => (
	<>
		<span className="visually-hidden">{CONSTANTS.COMPANY_NAME_SPOKEN}</span>
		<span aria-hidden="true">Ready<sup>RX</sup></span>
	</>
);

export default BrandName;
